import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Loader2, Users } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { fetchUsers } from '@/lib/api/users'

import { SettingsSection } from './SettingsSection'

export function UsersSettingsSection({ embedded = false }) {
  const [loading, setLoading] = useState(true)
  const [userCount, setUserCount] = useState(0)

  useEffect(() => {
    let active = true

    fetchUsers()
      .then((users) => {
        if (active) {
          setUserCount(users.length)
        }
      })
      .catch(() => {
        if (active) {
          setUserCount(0)
        }
      })
      .finally(() => {
        if (active) {
          setLoading(false)
        }
      })

    return () => {
      active = false
    }
  }, [])

  return (
    <SettingsSection
      id="users"
      icon={Users}
      title="Users"
      description="Reception logins and passwords"
      embedded={embedded}
    >
      {loading ? (
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Loader2 className="h-4 w-4 animate-spin" />
          Loading…
        </div>
      ) : (
        <div className="space-y-4">
          <p className="text-sm text-muted-foreground">
            {userCount === 1
              ? '1 person can log in to Salon Desk.'
              : `${userCount} people can log in to Salon Desk.`}
          </p>
          <div className="flex flex-wrap gap-2">
            <Button type="button" variant="outline" className="rounded-xl" asChild>
              <Link to="/admin/users">Manage users</Link>
            </Button>
            <Button type="button" variant="outline" className="rounded-xl" asChild>
              <Link to="/admin/roles">Roles & access</Link>
            </Button>
          </div>
        </div>
      )}
    </SettingsSection>
  )
}
